import React, { useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import { Parser } from 'html-to-react'
import useMediaQuery from '@mui/material/useMediaQuery';
import ModelContext from "../ModelContext";

export const VirtualTour = (props) => {
    const modelCtx = useContext(ModelContext);
    const [virtualTourLink, setVirtualTourLink] = useState("");

    const [isPreliminaryData, setIsPreliminaryData] = useState(false);

    const isTablet = useMediaQuery('(max-width:1024px)');
    const isMobile = useMediaQuery('(max-width:480px)');

    const vtImageLink = "images/" + modelCtx.inputModelData.workingFolder + "/main-vt.jpg";

    useEffect(() => {
        const getVirtualTour = async () => {
            const input = modelCtx.inputModelData;

            if ((input.idBasicModel !== 0) && (input.idModel !== 0)) {
                let apiUrl = "/api/model/virtualtour";

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.text(); // return a string
                    if (data) {
                        setVirtualTourLink(data);
                    } else {
                        //props.feedbackCallback("error", "Errore durante la lettura delle informazioni sulla societ�", true);
                    }

                } else {
                    const error = await response.text();
                    //props.feedbackCallback("error", error, true);
                }
            }
        }

        getVirtualTour();
    }, [modelCtx.inputModelData]);


    return (
        <div>

            <div className="row justify-content-center">
                <div className="col-12 bg-blue descriptions">
                    <div className="box">
                        <p className="color-white wow fadeInUp" data-wow-delay="0.4s">
                            <span className="title1">Virtual Tour</span><br /><br />
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <p>&nbsp;</p>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <a href={virtualTourLink} target="_blank">
                        <img src={vtImageLink} className="mainImageVirtualTour" /></a>
                </div>
            </div>
        </div>
    );
};

export default VirtualTour;
